import script from "./currency-info-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./currency-info-box.vue?vue&type=script&setup=true&lang=ts"

import "./currency-info-box.vue?vue&type=style&index=0&id=64e6a164&lang=scss"

const __exports__ = script;

export default __exports__